module.exports = __webpack_public_path__ + "img/brifecase-tick.716b009f.svg";